import React from 'react';
import { useTranslation } from 'react-i18next';

import { VerifyEmail } from '@/modules/payment';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

import TriangleExleminationMark from '~/images/shared/TriangleExleminationMark.svg';

const VerifyEmailBanner = () => {
  const { t } = useTranslation('common');
  const { openModal } = useModal();

  const handleClick = () => {
    openModal(<VerifyEmail />);
  };

  return (
    <div className='flex w-full items-center justify-between gap-16 rounded-xl bg-error-90 p-16 text-error-20'>
      <div className='flex items-center gap-1'>
        <span className='text-24'>
          <TriangleExleminationMark />
        </span>
        <span className='text-14'>{t('verify-email')}</span>
      </div>
      <div
        onClick={handleClick}
        className='cursor-pointer text-base font-medium'
      >
        {t('send-verification-email')}
      </div>
    </div>
  );
};

export { VerifyEmailBanner };
